import { useNavigate, useLocation } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState, useEffect, useRef } from "react";
import { TOAST_ERROR, TOAST_SUCCESS } from "../../../utils/common.service";
import { uploadImageOnAWS } from "../../aws/Service";
import { delete_blog_media, get_blog_details, update_blog } from "../../../api/apiHandler";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import Swal from "sweetalert2";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Select from 'react-select';

const Editor = ({ content, onChange }) => {
    return (
        <ReactQuill
            value={content}
            onChange={onChange}
            modules={Editor.modules}
            formats={Editor.formats}
            theme="snow"
            placeholder="Write something..."
            style={{ borderRadius: '10px' }}
        />
    );
};

Editor.modules = {
    toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        ["clean"],
    ],
};

Editor.formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
];

const panelOptions = [
    { label: 'Landing Page', value: 'landing_page' },
    { label: 'Teacher', value: 'teacher' },
    { label: 'Organization', value: 'organization' },
    { label: 'Organization Teacher', value: 'org_teacher' },
    { label: 'Parents', value: 'below_18' },
    { label: 'Kids', value: 'learner' },
    { label: 'Over 18', value: 'above_18' },
    { label: 'Schools-After School Centers', value: 'after_school' }
];

const EditBlog = ({ isLoader }) => {
    const navigate = useNavigate();
    const [previewImageUrls, setPreviewImageUrls] = useState([]);
    const [previewVideoUrls, setPreviewVideoUrls] = useState([]);
    const [newpreviewImageUrls, setNewPreviewImageUrls] = useState([]);
    const [newpreviewVideoUrls, setNewPreviewVideoUrls] = useState([]);
    const [blogData, setBlogData] = useState(null);

    const [lessonDetails, setLessonDetails] = useState([]);
    const [AttachmentData, setAttachmentData] = useState({});

    const [selectedPanels, setSelectedPanels] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [panelError, setPanelError] = useState('');

    const location = useLocation();
    const BlogId = location.state && location.state.BlogId;
    const AdminId = localStorage.getItem("aID");

    const handleSelectAllChange = (e) => {
        setSelectAll(e.target.checked);
        if (e.target.checked) {
            setSelectedPanels(panelOptions.map(o => o.value));
        } else {
            setSelectedPanels([]);
        }
        setPanelError('');
    };

    const handlePanelChange = (selectedOptions) => {
        const values = selectedOptions ? selectedOptions.map(o => o.value) : [];
        setSelectedPanels(values);
        setSelectAll(values.length === panelOptions.length);
        setPanelError('');
    };

    // Every section has its own title, description and optional link
    const sectionRules = {};
    lessonDetails.forEach((_, index) => {
        sectionRules[`blog_title_${index}`] = yup.string().trim()
            .required('Please enter title')
            .max(255, 'Title must be at most 255 characters');
        sectionRules[`blog_link_${index}`] = yup.string().test('is-url', 'Invalid URL format', function (value) {
            if (!value) return true;
            const regex = /^(https?|http?):\/\/[^\s$.?#].[^\s]*$/;
            return regex.test(value);
        }).nullable().notRequired();
    });

    const schema = yup.object().shape({
        title: yup.string()
            .matches(/^[a-zA-Z0-9!@#\$%\^&\*\(\)_\+\-=\[\]{};':"\\|,.<>\/?\s]+$/, 'Please enter proper title')
            .required("Please enter title"),
        ...sectionRules
    });

    const { register, handleSubmit, setValue, clearErrors, reset, watch, control, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const fetchBlogData = async () => {
        try {
            isLoader(true);
            const blog = await get_blog_details({ blog_id: BlogId });
            if (blog && blog.data) {
                setBlogData(blog.data);
                const { title, link, blogdata } = blog.data.blog_details;

                // Populate dynamic descriptions and S3 attachments
                const details = blogdata?.length ? blogdata.map((item) => ({
                    des_id: item.des_id,
                    title: item.title || '',
                    description: item.description,
                    link: item.link || '',
                    attachments: item.attachments || []
                })) : [{ title: '', description: '', link: '', attachments: [] }];

                // Older blogs kept one link on the blog itself; it now belongs to the first section
                if (link && !details[0].link) {
                    details[0].link = link;
                }

                setLessonDetails(details);

                const initialAttachments = {};
                details.forEach((item, index) => {
                    const attachmentsList = ["", "", "", "", "", ""];
                    if (item.attachments && Array.isArray(item.attachments)) {
                        item.attachments.forEach((attach, idx) => {
                            if (attach && attach.attachment) {
                                attachmentsList[idx] = {
                                    attachments: attach.attachment,
                                    attachment_type: attach.attachment_type || 'image'
                                };
                            }
                        });
                    }
                    initialAttachments[`attachment_${index}`] = attachmentsList;
                });
                setAttachmentData(initialAttachments);

                // Populate main images and videos
                const images = blog.data.blog_media.filter(media => media.type === 'image').map(media => ({
                    url: media.media,
                    id: media.id
                }));
                const videos = blog.data.blog_media.filter(media => media.type === 'video').map(media => ({
                    url: media.media,
                    id: media.id
                }));

                setPreviewImageUrls(images);
                setPreviewVideoUrls(videos);

                // Set initial values for Quill fields
                const quillValues = {};
                details.forEach((item, index) => {
                    quillValues[`blog_title_${index}`] = item.title;
                    quillValues[`blog_description_${index}`] = item.description || '';
                    quillValues[`blog_link_${index}`] = item.link;
                });
                reset({
                    title: title || '',
                    ...quillValues
                });
                console.log("blog.data.panels", blog.data.panels);
                // Pre-populate panels
                if (blog.data.panels && Array.isArray(blog.data.panels)) {
                    const panelValues = blog.data.panels.map(p => p.panel_name);
                    setSelectedPanels(panelValues);
                    setSelectAll(panelValues.length === panelOptions.length);
                }

                isLoader(false);
            } else {
                isLoader(false);
            }
        } catch (error) {
            isLoader(false);
            console.error("Error fetching blog:", error);
        }
    };

    useEffect(() => {
        fetchBlogData();
    }, []);

    const handleImageChange = async (image, Attachment_Index, fileIndex, type) => {
        if (!image) {
            TOAST_ERROR("No file selected. Please select a valid file.");
            return;
        }
        TOAST_SUCCESS("Your attachment has been uploaded!");
        const str = "attachment_" + Attachment_Index;
        const temp_arr = { ...AttachmentData };
        isLoader(true);
        const image_name = await uploadImageOnAWS(image, "lesson_attachments");
        if (temp_arr[str]) {
            temp_arr[str][fileIndex] = { attachments: image_name, attachment_type: type };
        } else {
            temp_arr[str] = ["", "", "", "", "", ""];
            temp_arr[str][fileIndex] = { attachments: image_name, attachment_type: type };
        }

        setAttachmentData(temp_arr);
        isLoader(false);
    };

    const handleDescriptionChange = (index, value) => {
        setLessonDetails(prevDetails => {
            const updatedDetails = [...prevDetails];
            updatedDetails[index] = {
                ...updatedDetails[index],
                description: value
            };
            return updatedDetails;
        });
    };

    const handleSectionFieldChange = (index, field, value) => {
        setLessonDetails(prevDetails => {
            const updatedDetails = [...prevDetails];
            updatedDetails[index] = {
                ...updatedDetails[index],
                [field]: value
            };
            return updatedDetails;
        });
    };

    const handleAddDescription = () => {
        setLessonDetails([...lessonDetails, { title: '', description: '', link: '', attachment: null }]);
    };

    const handleDeleteAttachment = (attachmentKey, attachmentIndex) => {
        setAttachmentData((prevState) => {
            const updatedAttachmentData = { ...prevState };
            if (updatedAttachmentData[attachmentKey]) {
                updatedAttachmentData[attachmentKey] = updatedAttachmentData[attachmentKey].filter(
                    (_, idx) => idx !== attachmentIndex
                );
            }
            return updatedAttachmentData;
        });
    };

    const handleRemoveDescription = (index) => {
        setLessonDetails(prevDetails => {
            const updated = prevDetails.filter((_, i) => i !== index);
            const newValues = {};
            updated.forEach((item, ind) => {
                newValues[`blog_title_${ind}`] = item.title || '';
                newValues[`blog_description_${ind}`] = item.description || '';
                newValues[`blog_link_${ind}`] = item.link || '';
            });

            setAttachmentData(prevAttach => {
                const newAttach = {};
                for (let i = 0; i < prevDetails.length; i++) {
                    if (i === index) continue;
                    const newIndex = i > index ? i - 1 : i;
                    if (prevAttach[`attachment_${i}`]) {
                        newAttach[`attachment_${newIndex}`] = prevAttach[`attachment_${i}`];
                    }
                }
                return newAttach;
            });

            setTimeout(() => {
                Object.keys(newValues).forEach(key => {
                    setValue(key, newValues[key]);
                });
            }, 10);

            return updated;
        });
    };

    // A blog carries one media item: a single image or a single video. Media already saved on the blog counts too.
    const [mainImages, setMainImages] = useState([]);
    const [mainVideos, setMainVideos] = useState([]);
    const [mediaError, setMediaError] = useState('');
    const imageInputRef = useRef(null);
    const videoInputRef = useRef(null);
    const BOTH_MEDIA_ERROR = "You can upload either one image or one video, not both. Please remove the image or the video.";

    const showMediaError = (message) => {
        setMediaError(message);
        TOAST_ERROR(message);
    };

    const handleChange = (e) => {
        const { name, files } = e.target;
        const fileArray = Array.from(files).slice(0, 1);

        if (fileArray.length) {
            const hasImage = previewImageUrls.length > 0 || mainImages.length > 0;
            const hasVideo = previewVideoUrls.length > 0 || mainVideos.length > 0;
            let message = '';
            if ((name === 'images' && hasVideo) || (name === 'videos' && hasImage)) {
                message = BOTH_MEDIA_ERROR;
            } else if (name === 'images' && previewImageUrls.length > 0) {
                message = "This blog already has an image. Please remove the existing image before uploading a new one.";
            } else if (name === 'videos' && previewVideoUrls.length > 0) {
                message = "This blog already has a video. Please remove the existing video before uploading a new one.";
            }
            if (message) {
                showMediaError(message);
                e.target.value = '';
                return;
            }
        }
        setMediaError('');

        if (name === 'images') {
            setMainImages(fileArray);
            const imageUrls = fileArray.map(file => URL.createObjectURL(file));
            setNewPreviewImageUrls(imageUrls);
        } else if (name === 'videos') {
            setMainVideos(fileArray);
            const videoUrls = fileArray.map(file => URL.createObjectURL(file));
            setNewPreviewVideoUrls(videoUrls);
        }
    };

    const handleRemoveNewMedia = (name) => {
        if (name === 'images') {
            setMainImages([]);
            setNewPreviewImageUrls([]);
            if (imageInputRef.current) imageInputRef.current.value = '';
        } else {
            setMainVideos([]);
            setNewPreviewVideoUrls([]);
            if (videoInputRef.current) videoInputRef.current.value = '';
        }
        setMediaError('');
    };

    const handleRemoveImage = (index, mediaId, e) => {
        e.preventDefault();
        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to delete this image?",
            showCancelButton: true,
            confirmButtonText: "Delete",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    delete_blog_media({ blog_image_id: mediaId }).then((response) => {
                        if (response.code == 1) {
                            const updatedImages = previewImageUrls.filter((image, idx) => idx !== index);
                            setPreviewImageUrls(updatedImages);
                            setMediaError('');
                            TOAST_SUCCESS(response.message);
                        } else {
                            TOAST_ERROR(response.message);
                        }
                    });
                } catch (error) {
                    console.error("Error deleting image:", error);
                }
            }
        });
    };

    const handleRemoveVideo = (index, mediaId, e) => {
        e.preventDefault();
        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to delete this video?",
            showCancelButton: true,
            confirmButtonText: "Delete",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    delete_blog_media({ blog_image_id: mediaId }).then((response) => {
                        if (response.code == 1) {
                            const updatedVideos = previewVideoUrls.filter((video, idx) => idx !== index);
                            setPreviewVideoUrls(updatedVideos);
                            setMediaError('');
                            TOAST_SUCCESS(response.message);
                        } else {
                            TOAST_ERROR(response.message);
                        }
                    });
                } catch (error) {
                    console.error("Error deleting video:", error);
                }
            }
        });
    };

    const onSubmit = async (data) => {
        if (selectedPanels.length === 0) {
            setPanelError('Please select at least one panel');
            return;
        }
        const imageCount = previewImageUrls.length + mainImages.length;
        const videoCount = previewVideoUrls.length + mainVideos.length;
        if (imageCount && videoCount) {
            showMediaError(BOTH_MEDIA_ERROR);
            return;
        }
        if (imageCount > 1 || videoCount > 1) {
            showMediaError("You can upload only one image or one video. Please remove the extra media.");
            return;
        }
        isLoader(true);

        var media = [];
        // Upload main images
        if (mainImages && mainImages.length > 0) {
            for (const image of mainImages) {
                var blog_image = await uploadImageOnAWS(image, "blogs");
                media.push({ media_type: 'image', name: blog_image });
            }
        }
        // Upload main videos
        if (mainVideos && mainVideos.length > 0) {
            for (const video of mainVideos) {
                var blog_video = await uploadImageOnAWS(video, "blogs");
                media.push({ media_type: 'video', name: blog_video });
            }
        }

        var description_arr = lessonDetails.map((lesson, index) => {
            var temp_obj = {};
            var temp_str = `blog_description_${index}`;
            temp_obj.title = (data[`blog_title_${index}`] || '').trim();
            temp_obj.description = data[temp_str] || '';
            temp_obj.link = data[`blog_link_${index}`] || '';
            temp_obj.images = '';
            temp_obj.des_id = lesson.des_id === undefined ? "0" : lesson.des_id.toString();

            var attach_str = `attachment_${index}`;
            if (AttachmentData[attach_str]) {
                var originalArray = AttachmentData[attach_str];
                var newArray = originalArray.filter(item => item !== '').map(item => {
                    return {
                        attachment: item.attachments?.split('/').pop() || '',
                        attachment_type: item.attachment_type || ''
                    };
                });
                temp_obj.attachments = newArray;
            } else {
                temp_obj.attachments = [];
            }
            return temp_obj;
        });

        var obj = {
            title: data.title,
            admin_id: AdminId,
            media: media,
            blog_id: BlogId,
            blogdata: description_arr,
            panels: selectedPanels
        };

        const response = await update_blog(obj);
        if (response.code == 1) {
            TOAST_SUCCESS(response.message);
            navigate('/blog');
            isLoader(false);
        } else {
            TOAST_ERROR(response.message);
            isLoader(false);
        }
    };

    const handleBack = () => {
        navigate(-1);
    };

    if (!blogData) {
        return <div>Loading...</div>;
    }

    return <>
        <JqueryLoad />
        <Hdashboard />
        <main>
            <div className="dashboard-app d-lg-flex">
                <header className="dashboard-toolbar d-lg-flex justify-content-between">
                    <div className="align-items-center justify-content-between d-flex">
                        <div className="d-flex align-items-center">
                            <a className="menu-toggle align-items-center d-lg-none d-flex">
                                <i className="fa fa-bars" />
                            </a>
                            <a href="index.php" className="d-lg-none d-block brand-logo">
                                <img src="./assets/images/logo.png" alt="logo" />
                            </a>
                        </div>
                    </div>
                </header>
                <div className="mx-5 mt-4 w-100">
                    <span onClick={handleBack} style={{ cursor: 'pointer' }}>
                        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" ></path>
                        </svg>
                        <span className="ms-2">Back</span>
                    </span>
                    <p className="d-flex justify-content-center fs-3 fw-500"> Edit Blog</p>
                    <div className="row align-items-center justify-content-center mt-5 mb-5">
                        <div className="col-lg-10">
                            <div className="card border-purple p-5" >
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="mb-4">
                                        <label htmlFor="title" className="form-label">Enter Title</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="title"
                                            placeholder="Enter title"
                                            {...register("title")}
                                        />
                                        {errors.title && (
                                            <div className="text-danger">{errors.title.message}</div>
                                        )}
                                    </div>

                                    {/* Panels Multi-Select */}
                                    <div className="mb-4">
                                        <label className="form-label">In which side you want to show this Blog:</label>
                                        {!selectAll && (
                                            <Select
                                                options={panelOptions}
                                                required
                                                value={panelOptions.filter(o => selectedPanels.includes(o.value))}
                                                className='mt-2'
                                                onChange={handlePanelChange}
                                                isSearchable={true}
                                                isMulti={true}
                                                placeholder="Select Panels..."
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        border: '1px solid rgba(102, 102, 102, 0.35)',
                                                        borderRadius: '12px',
                                                        padding: '5px 10px',
                                                        minHeight: '46px',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 9999,
                                                    }),
                                                }}
                                            />
                                        )}
                                        {panelError && (
                                            <div className="text-danger mt-1">{panelError}</div>
                                        )}
                                        {selectAll && (
                                            <input
                                                type="text"
                                                className="form-control py-2 mt-2"
                                                placeholder="All are selected"
                                                readOnly
                                                style={{ borderRadius: "12px" }}
                                            />
                                        )}
                                        <div className="form-check mt-2">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="selectAllEditBlog"
                                                checked={selectAll}
                                                onChange={handleSelectAllChange}
                                            />
                                            <label className="form-check-label text-secondary" htmlFor="selectAllEditBlog">Select All Panels</label>
                                        </div>
                                    </div>

                                    {/* Multiple Description Blocks */}
                                    {lessonDetails.map((lesson, index) => (
                                        <div className={`${index !== 0 ? "border rounded mb-4 p-4 position-relative mt-4" : "mb-4 position-relative"}`} key={index}>

                                            {/* Sleek, Absolute-Positioned Overlapping Black Circle Close Button */}
                                            {index !== 0 && (
                                                <span
                                                    onClick={() => handleRemoveDescription(index)}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '-15px',
                                                        right: '-15px',
                                                        cursor: 'pointer',
                                                        width: '32px',
                                                        height: '32px',
                                                        backgroundColor: '#000000',
                                                        color: '#ffffff',
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '18px',
                                                        fontWeight: 'bold',
                                                        zIndex: 10,
                                                        border: '2px solid #ffffff',
                                                        boxShadow: '0px 2px 5px rgba(0,0,0,0.2)'
                                                    }}
                                                    title="Remove Section"
                                                >
                                                    ×
                                                </span>
                                            )}

                                            <div className="form-group mb-4">
                                                <label className="form-label">Title</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    maxLength={255}
                                                    placeholder="Enter title"
                                                    {...register(`blog_title_${index}`, {
                                                        onChange: (e) => handleSectionFieldChange(index, 'title', e.target.value)
                                                    })}
                                                />
                                                {errors[`blog_title_${index}`] && (
                                                    <div className="text-danger mt-1">{errors[`blog_title_${index}`].message}</div>
                                                )}
                                            </div>

                                            <div className="form-group mb-4">
                                                <label className="form-label">Description</label>
                                                <div className="position-relative">
                                                    <Controller
                                                        name={`blog_description_${index}`}
                                                        control={control}
                                                        defaultValue=""
                                                        render={({ field }) => (
                                                            <Editor
                                                                content={field.value}
                                                                onChange={(value) => {
                                                                    const isEmpty = value.replace(/<[^>]*>/g, '').trim() === '';
                                                                    const validated = isEmpty ? '' : value;
                                                                    field.onChange(validated);
                                                                    handleDescriptionChange(index, validated);
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                    {errors[`blog_description_${index}`] && (
                                                        <div className="text-danger mt-1">
                                                            {errors[`blog_description_${index}`].message}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="form-group mb-4 attach_box">
                                                <label className="form-label">Attachments</label>
                                                <div className="position-relative">
                                                    <div className="textarea-wrapper" style={{ position: 'relative' }}>
                                                        <textarea
                                                            type="text"
                                                            className="form-control"
                                                            name={`attachments_text_${index}`}
                                                            rows={6}
                                                            readOnly
                                                            style={{ paddingBottom: '60px' }}
                                                        />
                                                        <div className="attachments-preview p-2" style={{
                                                            position: 'absolute',
                                                            top: 5,
                                                            left: 5,
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                            gap: '5px',
                                                            zIndex: 4
                                                        }}>
                                                            {AttachmentData[`attachment_${index}`]?.map((item, idx) =>
                                                                item && item.attachments ? (
                                                                    <span key={idx} className="badge bg-light text-dark p-2 border d-flex align-items-center">
                                                                        {item.attachments.split('/').pop()}
                                                                        <button
                                                                            type="button"
                                                                            className="btn-close ms-2"
                                                                            style={{ fontSize: '10px' }}
                                                                            onClick={() => handleDeleteAttachment(`attachment_${index}`, idx)}
                                                                        >
                                                                        </button>
                                                                    </span>
                                                                ) : null
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* absolute-positioned attachment options at bottom right of the textarea */}
                                                    <div className="att_icon_list position-absolute" style={{ bottom: '15px', right: '15px', zIndex: 5 }}>
                                                        <ul className="d-flex align-items-center justify-content-start list-unstyled gap-3" style={{ padding: 0, margin: 0 }}>
                                                            <li>
                                                                <label htmlFor={`attach1_${index}`} style={{ margin: 0 }}>
                                                                    <a style={{
                                                                        cursor: 'pointer',
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        boxShadow: '0px 3px 5px rgba(0,0,0,0.26)',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        borderRadius: '100%',
                                                                        backgroundColor: '#ffffff'
                                                                    }}>
                                                                        <img src="./assets/images/attach1.png" alt="All formats" style={{ width: '16px', height: '16px' }} />
                                                                    </a>
                                                                </label>
                                                                <input
                                                                    type="file"
                                                                    id={`attach1_${index}`}
                                                                    onInput={(e) => {
                                                                        const file = e.target.files[0];
                                                                        if (!file) return;
                                                                        const fileType = file.type.startsWith('image')
                                                                            ? 'image'
                                                                            : file.type.startsWith('video')
                                                                                ? 'video'
                                                                                : file.type === 'application/pdf'
                                                                                    ? 'pdf'
                                                                                    : file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                                                                                        ? 'docx'
                                                                                        : 'xlsx';
                                                                        handleImageChange(file, index, 0, fileType);
                                                                    }}
                                                                    accept="image/*,video/*,application/pdf,.docx,.xlsx"
                                                                    style={{ display: 'none' }}
                                                                />
                                                            </li>
                                                            <li>
                                                                <label htmlFor={`attach2_${index}`} style={{ margin: 0 }}>
                                                                    <a style={{
                                                                        cursor: 'pointer',
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        boxShadow: '0px 3px 5px rgba(0,0,0,0.26)',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        borderRadius: '100%',
                                                                        backgroundColor: '#ffffff'
                                                                    }}>
                                                                        <img src="./assets/images/attach2.png" alt="video" style={{ width: '16px', height: '16px' }} />
                                                                    </a>
                                                                </label>
                                                                <input type="file" id={`attach2_${index}`} onInput={(e) => handleImageChange(e.target.files[0], index, 1, "video")} accept="video/*" style={{ display: 'none' }} />
                                                            </li>
                                                            <li>
                                                                <label htmlFor={`attach3_${index}`} style={{ margin: 0 }}>
                                                                    <a style={{
                                                                        cursor: 'pointer',
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        boxShadow: '0px 3px 5px rgba(0,0,0,0.26)',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        borderRadius: '100%',
                                                                        backgroundColor: '#ffffff'
                                                                    }}>
                                                                        <img src="./assets/images/attach3.png" alt="image" style={{ width: '16px', height: '16px' }} />
                                                                    </a>
                                                                </label>
                                                                <input type="file" id={`attach3_${index}`} accept="image/*" onInput={(e) => handleImageChange(e.target.files[0], index, 2, "image")} style={{ display: 'none' }} />
                                                            </li>
                                                            <li>
                                                                <label htmlFor={`attach4_${index}`} style={{ margin: 0 }}>
                                                                    <a style={{
                                                                        cursor: 'pointer',
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        boxShadow: '0px 3px 5px rgba(0,0,0,0.26)',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        borderRadius: '100%',
                                                                        backgroundColor: '#ffffff'
                                                                    }}>
                                                                        <img src="./assets/images/attach4.png" alt="docx" style={{ width: '16px', height: '16px' }} />
                                                                    </a>
                                                                </label>
                                                                <input type="file" id={`attach4_${index}`} accept=".docx" onInput={(e) => handleImageChange(e.target.files[0], index, 3, "docx")} style={{ display: 'none' }} />
                                                            </li>
                                                            <li>
                                                                <label htmlFor={`attach5_${index}`} style={{ margin: 0 }}>
                                                                    <a style={{
                                                                        cursor: 'pointer',
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        boxShadow: '0px 3px 5px rgba(0,0,0,0.26)',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        borderRadius: '100%',
                                                                        backgroundColor: '#ffffff'
                                                                    }}>
                                                                        <img src="./assets/images/attach5.png" alt="xlsx" style={{ width: '16px', height: '16px' }} />
                                                                    </a>
                                                                </label>
                                                                <input type="file" id={`attach5_${index}`} onInput={(e) => handleImageChange(e.target.files[0], index, 4, "xlsx")} accept=".xlsx" style={{ display: 'none' }} />
                                                            </li>
                                                            <li>
                                                                <label htmlFor={`attach6_${index}`} style={{ margin: 0 }}>
                                                                    <a style={{
                                                                        cursor: 'pointer',
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        boxShadow: '0px 3px 5px rgba(0,0,0,0.26)',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        borderRadius: '100%',
                                                                        backgroundColor: '#ffffff'
                                                                    }}>
                                                                        <img src="./assets/images/attach6.png" alt="pdf" style={{ width: '16px', height: '16px' }} />
                                                                    </a>
                                                                </label>
                                                                <input type="file" id={`attach6_${index}`} onInput={(e) => handleImageChange(e.target.files[0], index, 5, "pdf")} accept=".pdf" style={{ display: 'none' }} />
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-group mb-2">
                                                <label className="form-label">Enter Link Or URL (Optional)</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter link"
                                                    {...register(`blog_link_${index}`, {
                                                        onChange: (e) => handleSectionFieldChange(index, 'link', e.target.value)
                                                    })}
                                                />
                                                {errors[`blog_link_${index}`] && (
                                                    <div className="text-danger mt-1">{errors[`blog_link_${index}`].message}</div>
                                                )}
                                            </div>
                                        </div>
                                    ))}

                                    <div className="d-flex justify-content-end mt-3 mb-4">
                                        <a
                                            className="text-decoration-underline text-purple fw-bold font-15"
                                            style={{ cursor: 'pointer', color: '#570861' }}
                                            onClick={handleAddDescription}
                                        >
                                            + Add Another Title, Attachment and Description
                                        </a>
                                    </div>

                                    <div className="mb-4">
                                        <label className="form-label mb-1 fw-bold" htmlFor="images">Add Cover Image</label>
                                        <small className="text-muted d-block mb-4">A blog can have one cover: either an image or a video.</small>

                                        <div className="row mb-3">
                                            {previewImageUrls.map((imageUrl, index) => (
                                                <div className="col-md-2 mb-3" key={index}>
                                                    <div className="card image-card" style={{ height: "150px", width: "150px", position: 'relative' }}>
                                                        <img src={imageUrl.url} alt={`Selected Image ${index}`} style={{ height: "150px", width: "150px", objectFit: 'cover' }} />
                                                        <button type="button" className="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={(e) => handleRemoveImage(index, imageUrl.id, e)}>&times;</button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <input type="file" onChange={handleChange} ref={imageInputRef} className="form-control" id="images" accept=".jpg, .jpeg, .png" name="images" />
                                    </div>

                                    <div className="row mb-4">
                                        {newpreviewImageUrls.map((imageUrl, index) => (
                                            <div className="col-md-2 mb-3" key={index}>
                                                <div className="card image-card" style={{ height: "150px", width: "150px", position: 'relative' }}>
                                                    <img src={imageUrl} alt={`Selected Image ${index}`} style={{ height: "150px", width: "150px", objectFit: 'cover' }} />
                                                    <button type="button" className="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => handleRemoveNewMedia('images')}>&times;</button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <hr />

                                    <div className="mb-4">
                                        <label className="form-label fw-bold" htmlFor="videos">Add Cover Video</label>
                                        <div className="row mb-3">
                                            {previewVideoUrls.map((videoUrl, index) => (
                                                <div className="col-md-2 mb-2" key={index}>
                                                    <div className="video-card" style={{ height: "150px", width: "150px", position: 'relative' }}>
                                                        <video controls style={{ height: "150px", width: "150px", objectFit: 'cover' }}>
                                                            <source src={videoUrl.url} type="video/mp4" />
                                                            Your browser does not support the video tag.
                                                        </video>
                                                        <button type="button" className="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={(e) => handleRemoveVideo(index, videoUrl.id, e)}>&times;</button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <input type="file" onChange={handleChange} ref={videoInputRef} className="form-control" id="videos" accept="video/*" name="videos" />
                                    </div>
                                    <div className="row mb-4">
                                        {newpreviewVideoUrls.map((videoUrl, index) => (
                                            <div className="col-md-2 mb-2" key={index}>
                                                <div className="video-card" style={{ height: "150px", width: "150px", position: 'relative' }}>
                                                    <video controls style={{ height: "150px", width: "150px", objectFit: 'cover' }}>
                                                        <source src={videoUrl} type="video/mp4" />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                    <button type="button" className="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => handleRemoveNewMedia('videos')}>&times;</button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {mediaError && <div className="text-danger mb-4">{mediaError}</div>}
                                    <div className="d-flex justify-content-start mt-5">
                                        <button type="submit" className="btn-theme bg-yellow mb-xl-0 mb-1 d-inline-block">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </>
};

export default EditBlog;
